import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

const getRedirectUri = (): string => {
  const envRedirectUri = import.meta.env.VITE_OIDC_REDIRECT_URI;
  if (envRedirectUri) {
    return envRedirectUri;
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}`;
  }
  return 'http://localhost:3000';
};

const getPostLogoutRedirectUri = (): string => {
  const envPostLogoutUri = import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI;
  if (envPostLogoutUri) {
    return envPostLogoutUri;
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/login`;
  }
  return 'http://localhost:3000/login';
};

export const oidcConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY || 'https://account.enrigin.com.cn/realms/official-site',
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID || 'support-cent-client-pub',
  redirect_uri: getRedirectUri(),
  response_type: 'code',
  scope: 'openid profile email',
  post_logout_redirect_uri: getPostLogoutRedirectUri(),
  silent_redirect_uri: `${getRedirectUri()}/silent-renew.html`,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  loadUserInfo: true,
  monitorSession: false,
  response_mode: 'query',
  filterProtocolClaims: true,
};

export const getOidcConfig = (): UserManagerSettings => ({
  ...oidcConfig,
  redirect_uri: getRedirectUri(),
  post_logout_redirect_uri: getPostLogoutRedirectUri(),
  silent_redirect_uri: `${getRedirectUri()}/silent-renew.html`,
});

export const validateOidcConfig = (): boolean => {
  const { authority, client_id, redirect_uri } = oidcConfig;

  if (!authority) {
    console.error('OIDC configuration error: VITE_OIDC_AUTHORITY is not defined');
    return false;
  }

  if (!client_id) {
    console.error('OIDC configuration error: VITE_OIDC_CLIENT_ID is not defined');
    return false;
  }

  if (!redirect_uri) {
    console.error('OIDC configuration error: redirect_uri is not defined');
    return false;
  }

  try {
    new URL(authority);
  } catch {
    console.error('OIDC configuration error: Invalid authority URL:', authority);
    return false;
  }

  return true;
};

export const getOidcEnvironmentInfo = () => ({
  authority: oidcConfig.authority,
  clientId: oidcConfig.client_id,
  redirectUri: oidcConfig.redirect_uri,
  scope: oidcConfig.scope,
  responseType: oidcConfig.response_type,
  automaticSilentRenew: oidcConfig.automaticSilentRenew,
});

export const debugOidcConfig = () => {
  if (import.meta.env.DEV) {
    console.log('=== OIDC Configuration Debug ===');
    console.log(getOidcEnvironmentInfo());
    console.log('================================');
  }
};
